import { BookOpen } from "lucide-react";
import { TERMS, GLOSSARY_SETS } from "@/lib/glossary";

export const Glossary = ({ set, title = "Jargon buster" }) => {
  const keys = GLOSSARY_SETS[set] || [];
  return (
    <section data-testid={`glossary-${set}`} className="mt-10 rounded-3xl border border-amber-200 bg-gradient-to-br from-amber-50 to-white p-6 sm:p-8">
      <p className="flex items-center gap-2 font-display font-extrabold text-xl"><BookOpen className="w-5 h-5 text-amber-600" />{title}</p>
      <p className="text-sm text-slate-500 mt-1">Plain-English meaning of the terms used above.</p>
      <dl className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-5">
        {keys.map((k) => (
          <div key={k} data-testid={`glossary-term-${k.toLowerCase()}`} className="border-l-2 border-amber-300 pl-4">
            <dt className="font-bold text-slate-900 text-sm">{TERMS[k][0]}</dt>
            <dd className="text-sm text-slate-600 mt-1 leading-relaxed">{TERMS[k][1]}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
};
